<template>
  <div :class="'relative animation-ready'">
    <div>
      <slot name="header" :class="{ active: active }"></slot>
    </div>

    <!--  <klaus-painter
      v-if="data.heading"
      :data="
        typeof data.heading == 'string' && JSON.parse(data.heading)
          ? JSON.parse(data.heading)
          : data.heading
      "
      :class="{ active: isActive }"
      :k-refs="{ Acordeon: self, ...kRefs }"
      @click.native="toggleDropdown"
    /> -->
    <transition-expanded>
      <div v-show="active"><slot name="body"> </slot></div>

      <!--  <div v-show="isActive && data.body">
        <klaus-painter
          :data="
            typeof data.body == 'string' && JSON.parse(data.body)
              ? JSON.parse(data.body)
              : data.body
          "
          :k-refs="{ Acordeon: self, ...kRefs }"
        />
        
      </div> -->
    </transition-expanded>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import TransitionExpanded from "../../../TransitionExpanded.vue"
export default {
  name: "Acordeon",
  props: ["data", "kRefs", "loop", "active"],

  data() {
    return {
      isActive: false
    }
  },
  components: {
    "klaus-painter": () => import("@/components/UI/Painter/KlausPainter"),
    TransitionExpanded
  },
  computed: {
    ...mapGetters(["acordeon"]),
    self() {
      return this
    }
  },
  methods: {
    ...mapActions(["UPDATE_general"]),
    toggleDropdown() {
      //console.log("ME EXPANDÍ")
      this.isActive = this.active
      //this.$emit("text", this.isActive)

      //console.log("Del lado del padre", this.isActive)
    },
    hideDropdown() {
      this.isActive = false
    }
  }
}
</script>
